import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const TITLE_HOME = 'home'
export const SAMPLE_SETTINGS = 'Sample settings'
export const YES = 'Yes'
export const NO = 'No'
export const LOADING = 'loading'
export const USE_PANEL = 'use panel'
export const OPTION_NOT_SELECTED = 'option not selected'
export const OPTION_SELECTED = 'option selected'
export const COPY_URL = 'copy url'
export const COPIED = 'copied'
export const SAMPLE_LIVE_INFO = 'sample live info'
export const SAMPLE_PAUSED_INFO = 'sample paused info'
export const LIVE = 'live'
export const PAUSED = 'paused'

export default {
  [PORTUGUESE]: {
    [TITLE_HOME]: 'Pagina Inicial',
    [SAMPLE_SETTINGS]: 'Configurações de Amostra',
    [YES]: 'Sim',
    [NO]: 'Não',
    [LOADING]: 'Carregando',
    [USE_PANEL]: 'Usará o Painel da Offerwise?',
    [OPTION_NOT_SELECTED]: 'Essa opção não poderá ser alterada posteriormente.',
    [OPTION_SELECTED]: 'Esta opção não pode mais ser alterada.',
    [COPY_URL]: 'Copiar URL',
    [COPIED]: 'Copiado',
    [SAMPLE_LIVE_INFO]: `Esta pesquisa está coletando respostas nesse momento.</br></br>
    Você não pode modificar o questionário e, caso decida fazê-lo, todas as respostas coletadas até o momento serão excluídas permanentemente.</br></br>
    Vá para a seção "Sample/Cotas" e selecione "Pausar amostra" para interromper a coleta de respostas`,
    [SAMPLE_PAUSED_INFO]: `Esta pesquisa não está coletando respostas no momento.</br></br>
    Caso você já tenha coletado respostas, esteja ciente de que qualquer modificação feita no questionário excluirá permanentemente todas as respostas coletadas até o momento.</br></br>
    Vá para a seleção "Sample/Quotas" e selecione "Começar Campo" para começar a coletar respostas.
    `,
    [LIVE]: 'Live',
    [PAUSED]: 'Pausado',
  },

  [ENGLISH]: {
    [TITLE_HOME]: 'Home',
    [SAMPLE_SETTINGS]: 'Sample Settings',
    [YES]: 'Yes',
    [NO]: 'No',
    [LOADING]: 'Loading',
    [USE_PANEL]: "Will use Offerwise's Panel?",
    [OPTION_NOT_SELECTED]: 'This option cannot be changed later.',
    [OPTION_SELECTED]: 'This option can’t be updated.',
    [COPY_URL]: 'Copy URL',
    [COPIED]: 'Copied',
    [SAMPLE_LIVE_INFO]: `This survey is currently collecting responses.</br></br>
    You are not able to modify the questionnaire, and in case you decide to do so, all of the answers collected so far will be permanently deleted.</br></br>
    Go to "Sample/Quotas" section and select "Paused Sample" stop collecting
    responses.`,
    [SAMPLE_PAUSED_INFO]: `This survey is not collecting responses right now.</br></br>
    In case you have already collected responses, be aware thar any modifications made on the questionnaire will permanently delete all of the response collected so far.</br></br>
    Go to "Sample/Quotas" selection and select "Launch Sample" to start collecting responses.
    `,
    [LIVE]: 'Live',
    [PAUSED]: 'Paused',
  },

  [SPANISH]: {
    [TITLE_HOME]: 'Página de Inicio',
    [SAMPLE_SETTINGS]: 'Configuraciones de Muestra',
    [YES]: 'Sí',
    [NO]: 'No',
    [LOADING]: 'Cargando',
    [USE_PANEL]: '¿Usará el Panel de Offerwise?',
    [OPTION_NOT_SELECTED]: 'Esta opción no podrá ser alterada.',
    [OPTION_SELECTED]: 'Esta opción ya no está disponible.',
    [COPY_URL]: 'Copiar URL',
    [COPIED]: 'Copiado',
    [SAMPLE_LIVE_INFO]: `Esta encuesta está recolectando respuestas en este momento.</br></br>
    No es posible modificar el cuestionario y, en caso de que decida hacerlo, todas las respuestas recopiladas hasta el momento van a ser eliminadas de forma permanente.</br></br>
    Vaya a la sección "Sample/Cuotas" y seleccione "Pausar muestra" para dejar de recopilar respuestas.`,
    [SAMPLE_PAUSED_INFO]: `Esta encuesta no está recopilando respuestas en este momento.</br></br>
    En caso de que ya haya recopilado respuestas, tenga en cuenta que cualquier modificación realizada en el cuestionario eliminará de forma permanente todas las respuestas recopiladas hasta el momento.</br></br>
    Vaya a la sección "Sample/Cuotas" y seleccione "Empezar Campo" para comenzar a recopilar respuestas.`,
    [LIVE]: 'Live',
    [PAUSED]: 'En Pausa',
  },
}
